var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import classNames from 'classnames';
import Signals from '../../../../signals/Signals';
import AlertNotification from './AlertNotification';
var UID = 0;
/**
 *
 */
var Notifications = /** @class */ (function (_super) {
    __extends(Notifications, _super);
    /**
     *
     * @param props
     */
    function Notifications(props) {
        var _this = _super.call(this, props) || this;
        _this.messageCount = 0;
        _this.state = {
            show: false,
            color: 'info',
            alertMessages: []
        };
        _this.show = _this.show.bind(_this);
        _this.onAlertMessageClosed = _this.onAlertMessageClosed.bind(_this);
        Signals.ShowNotification.add(_this.show);
        return _this;
    }
    /**
     *
     */
    Notifications.prototype.componentWillUnmount = function () {
        Signals.ShowNotification.remove(this.show);
    };
    /**
     *
     * @return {*}
     */
    Notifications.prototype.render = function () {
        var classes = classNames({
            'notifications--show': this.state.alertMessages.length > 0,
            'notifications--hide': this.state.alertMessages.length === 0
        });
        return (React.createElement("div", { className: "notifications ".concat(classes) }, this.state.alertMessages));
    };
    /**
     *
     */
    Notifications.prototype.onAlertMessageClosed = function (uid) {
        var foundIndex = -1;
        var alertMessages = this.state.alertMessages;
        alertMessages.forEach(function (message, index) {
            if (message.props.uid === uid) {
                foundIndex = index;
            }
        });
        if (foundIndex >= 0) {
            alertMessages.splice(foundIndex, 1);
            this.forceUpdate();
        }
    };
    /**
     * @param message
     * @param color
     * @param autoClose
     */
    Notifications.prototype.show = function (message, color, autoClose) {
        if (color === void 0) { color = 'info'; }
        if (autoClose === void 0) { autoClose = true; }
        var alertMessages = this.state.alertMessages;
        alertMessages.push(React.createElement(AlertNotification, { key: 'am-' + ++this.messageCount, uid: UID++, message: message, color: color, autoClose: autoClose, onClosed: this.onAlertMessageClosed }));
        this.forceUpdate();
    };
    return Notifications;
}(React.Component));
export default Notifications;
